"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.trim.js");
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _router = _interopRequireWildcard(require("@/router"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var state = {
  uuid: '',
  email: '',
  status: '',
  token: (0, _cookie.getCookie)('ACCESS_TOKEN'),
  refreshToken: (0, _cookie.getCookie)('REFRESH_TOKEN'),
  name: '',
  avatar: '',
  roles: [],
  introduction: '',
  expiryTime: '',
  metadata: {},
  givenName: '',
  familyName: ''
};
var mutations = {
  SET_UUID: function SET_UUID(state, uuid) {
    state.uuid = uuid;
  },
  SET_EMAIL: function SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_STATUS: function SET_STATUS(state, status) {
    state.status = status;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN: function SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar.length > 0 ? avatar : require('@/assets/otr/images/default_avatar.png');
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_EXPIRY_TIME: function SET_EXPIRY_TIME(state, time) {
    state.expiryTime = time;
  },
  SET_METADATA: function SET_METADATA(state, metadata) {
    state.metadata = metadata;
  },
  SET_GIVEN_NAME: function SET_GIVEN_NAME(state, givenName) {
    state.givenName = givenName;
  },
  SET_FAMILY_NAME: function SET_FAMILY_NAME(state, familyName) {
    state.familyName = familyName;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    // const { username, password } = userInfo
    var username = userInfo.username.trim();
    var password = userInfo.password.trim();
    return new Promise(function (resolve, reject) {
      (0, _user.login)(username, password).then(function (response) {
        var data = response.data;

        // console.log('Store-User-login-response', data)

        commit('SET_UUID', data.profile.uuid);
        commit('SET_EMAIL', data.profile.email);
        commit('SET_STATUS', data.profile.status);
        commit('SET_TOKEN', data.accessToken);
        commit('SET_REFRESH_TOKEN', data.refreshToken);
        commit('SET_NAME', data.profile.givenName + ' ' + data.profile.middleName + ' ' + data.profile.familyName);
        commit('SET_AVATAR', data.profile.profilePic);
        // commit('SET_ROLES', data.profile.role)
        commit('SET_INTRODUCTION', data.profile.bio);
        commit('SET_EXPIRY_TIME', (0, _momentTimezone.default)().utc().add(1, 'hours'));
        commit('SET_METADATA', data.profile.metadata || {});
        commit('SET_GIVEN_NAME', data.profile.givenName);
        commit('SET_FAMILY_NAME', data.profile.familyName);
        (0, _log.showDebugLog)('My Roles', data.profile.role);

        // set cookies
        (0, _cookie.setCookie)('ACCESS_TOKEN', data.accessToken);
        (0, _cookie.setCookie)('REFRESH_TOKEN', data.refreshToken);
        (0, _cookie.setCookie)('UUID', data.profile.uuid);
        // setCookie('ROLES', data.profile.role.join('|'))
        (0, _cookie.setCookie)('EMAIL', data.profile.email);
        resolve();
      }).catch(function (error) {
        reject(error);
        // console.log('Store-User-login-err', error)
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      // console.log('store-getInfo', token)
      (0, _user.getInfo)(token).then(function (response) {
        var data = response.data;

        // console.log('store-getInfo-response', data)

        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var role = data.role;

        // roles must be a non-empty array
        if (!role || role.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_UUID', data.uuid);
        commit('SET_EMAIL', data.email);
        commit('SET_STATUS', data.status);
        commit('SET_NAME', data.givenName + ' ' + (data.middleName ? data.middleName : '') + ' ' + data.familyName);
        commit('SET_AVATAR', data.profilePic);
        commit('SET_INTRODUCTION', data.bio);
        commit('SET_ROLES', data.role);
        commit('SET_METADATA', data.metadata || {});
        commit('SET_GIVEN_NAME', data.givenName);
        commit('SET_FAMILY_NAME', data.familyName);
        resolve(data);
      }).catch(function (error) {
        reject(error);
        // console.log('store-getInfo-err', error)
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      commit('SET_UUID', '');
      commit('SET_EMAIL', '');
      commit('SET_STATUS', '');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_NAME', '');
      commit('SET_AVATAR', '');
      commit('SET_ROLES', []);
      commit('SET_METADATA', {});
      commit('SET_GIVEN_NAME', '');
      commit('SET_FAMILY_NAME', '');

      // set cookies
      (0, _cookie.removeCookie)('ACCESS_TOKEN');
      (0, _cookie.removeCookie)('REFRESH_TOKEN');
      (0, _cookie.removeCookie)('UUID');
      (0, _cookie.removeCookie)('ROLES');
      (0, _cookie.removeCookie)('EMAIL'); // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  refreshToken: function refreshToken(_ref4, rToken) {
    var commit = _ref4.commit;
    return new Promise(function (resovle, reject) {
      // showDebugLog('store-refreshToken-param', rToken)

      (0, _user.refreshCognitoToken)(rToken).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.accessToken);
        commit('SET_EXPIRY_TIME', (0, _momentTimezone.default)().utc().add(1, 'hours'));
        (0, _cookie.setCookie)('ACCESS_TOKEN', data.accessToken);
        resovle();
      }).catch(function (error) {
        var msg = typeof error.data === 'undefined' ? error : error.data.message;
        (0, _log.showDebugLog)('store-refreshToken-error', msg);
        // reject('LAP-A0001-2 : ' + 'Unknown error. Please signout and signin again.')
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_UUID', '');
      commit('SET_EMAIL', '');
      commit('SET_STATUS', '');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_NAME', '');
      commit('SET_AVATAR', '');
      commit('SET_ROLES', []);
      commit('SET_METADATA', {});
      commit('SET_GIVEN_NAME', '');
      commit('SET_FAMILY_NAME', '');

      // set cookies
      (0, _cookie.removeCookie)('ACCESS_TOKEN');
      (0, _cookie.removeCookie)('REFRESH_TOKEN');
      (0, _cookie.removeCookie)('UUID');
      (0, _cookie.removeCookie)('ROLES');
      (0, _cookie.removeCookie)('EMAIL');
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  },
  redirectLandingPage: function redirectLandingPage(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      _router.default.push('/dashboard');
      resolve();
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};